import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SetupComplete = ({ descriptor }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const isActive = descriptor?.status === "active";

  const handlePrimary = () => {
    if (isActive) {
      navigate(`/activeevent/${descriptor.eventId}`, {
        state: { page: descriptor.eventPage || "mixer" },
      });
      return;
    }
    navigate("/");
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        px: 3,
      }}
    >
      <CheckCircleIcon
        sx={{ fontSize: 96, color: theme.palette.primary.main, mb: 2 }}
      />
      <Typography variant="h4" sx={{ mb: 1 }}>
        {t("setup.complete.title")}
      </Typography>
      {descriptor?.eventName && (
        <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 1 }}>
          {descriptor.eventName}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        {isActive
          ? t("setup.complete.active")
          : t("setup.complete.pending")}
      </Typography>

      <Button
        className="tnfm-pill-btn"
        variant="contained"
        fullWidth
        sx={{ maxWidth: 360 }}
        onClick={handlePrimary}
      >
        {isActive
          ? t("setup.complete.cta.active")
          : t("setup.complete.cta.pending")}
      </Button>
    </Box>
  );
};

export default SetupComplete;
